import icon from './svg/Writing';
import { createIconComp } from './Core/createIconComp';

export const WritingIcon = createIconComp({ icon });
